import { useQuery } from "react-query";
import axios from "axios";

const useUserWishlist = () => {
  const headers = {
    token: localStorage.getItem("userToken"),
  };
  const getLoggedInUserCart = async () => {
    try {
      const response = await axios.get(
        "https://ecommerce.routemisr.com/api/v1/wishlist",
        {
          headers,
        }
      );
      return response.data;
    } catch (error) {
      throw error.response.data.message;
    }
  };

  return useQuery("wishlist", () => getLoggedInUserCart());
};
export default useUserWishlist;
